import React, { useState, useEffect } from "react";
import { Modal, Button } from "semantic-ui-react";
import { UsersDB } from "../../../../api";
import "./UserDetailsModal.scss";

export function UserDetailsModal({ open, onClose, user, id_Client }) {
  const [details, setDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const usersDb = new UsersDB();
      const allUsersData = await usersDb.getAllUsersByClient(id_Client);
      //console.log('allUsersData', allUsersData);
      //console.log('user', user.name);

      if (allUsersData && Array.isArray(allUsersData.users)) {
        const userData = allUsersData.users.find((u) => u.name === user.name);
        setDetails(userData ? userData.data : []);
      } else {
        console.error("Data is not structured as expected:", allUsersData);
        setDetails([]);
      }
    };

    if (open) {
      fetchData();
    }
  }, [open, user.name, id_Client]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="large"
      className="user-details-modal"
    >
      <Modal.Header>{user.name} ha realizado :</Modal.Header>
      <Modal.Content>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nivel</th>
                <th>Tarea</th>
                <th>Progreso</th>
                <th>Tiempo</th>
                <th>Completado</th>
              </tr>
            </thead>
            <tbody>
              {details.map((detail, index) => (
                <tr key={index}>
                  <td>{detail.level}</td>
                  <td>{detail.tarea}</td>
                  <td>{detail.progress}</td>
                  <td>{detail.time}</td>
                  <td>
                    {detail.progress === "100%" || detail.progress === "100"
                      ? "Sí"
                      : "No"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
}
